import React from "react";
import "../index.css";

const achievements = [
  {
    tag: "Award",
    tagClass: "achievement-tag--award",
    title: "University of Bristol Global Alumni Award 2025",
    desc: "Recognised with the Alumni of the Year Award for Global Citizenship by the University of Bristol for outstanding contribution to society through technology and education.",
    link: "https://www.bristol.ac.uk/alumni/alumni-awards/year/2025/global/",
  },
  {
    tag: "Speaking",
    tagClass: "achievement-tag--speaking",
    title: "Speaker at Chatham House — Iraq Initiative Conference 2025",
    desc: "Invited to speak at the Iraq Initiative Conference at Chatham House, London — one of the world's most respected think tanks — representing women in tech in Iraq.",
    link: "https://shecodestooiq.com/news/founder-speaker-chatham-house-conference",
  },
  {
    tag: "Feature",
    tagClass: "achievement-tag--feature",
    title: "UNITAR: Leaving No One Behind in the Digital World",
    desc: "Featured by the United Nations Institute for Training and Research for pioneering work on digital inclusion and empowering women in Iraq.",
    link: "https://unitar.org/about/news-stories/news/leaving-no-one-behind-digital-world",
  },
  {
    tag: "Feature",
    tagClass: "achievement-tag--feature",
    title: "UNITAR: Showing Women in Iraq You Can Do Anything",
    desc: "A UNITAR story on the real-world impact of She Codes Too — how it's changing women's confidence, careers, and economic futures in Iraq.",
    link: "https://unitar.org/about/news-stories/stories/showing-women-iraq-you-can-do-anything",
  },
  {
    tag: "Press",
    tagClass: "achievement-tag--press",
    title: "Women Rock: Raghad al-Abboodi — She Codes Too",
    desc: "Profiled in SR2's Women Rock series, celebrating women making a lasting impact in technology, leadership, and social change.",
    link: "https://sr2rec.com/womenrock/raghad-al-abboodi-she-codes-too/",
  },
  {
    tag: "Press",
    tagClass: "achievement-tag--press",
    title: "She Codes Too Graduation & Demo Day — Iraq News",
    desc: "Iraq News covers the She Codes Too graduation and demo day, showcasing the achievements of the next generation of Iraqi women in tech.",
    link: "https://www.iraqinews.com/tech/she-codes-too-graduation-and-demo-day/",
  },
  {
    tag: "Podcast",
    tagClass: "achievement-tag--podcast",
    title: "Podcast: Raghad al-Abboodi on Women, Tech & Change",
    desc: "Featured on a podcast discussing women's empowerment, technology education, and the impact of She Codes Too in Iraq and beyond.",
    link: "https://www.youtube.com/watch?v=gHEGYIe2ayU",
  },
  {
    tag: "Speaking",
    tagClass: "achievement-tag--speaking",
    title: "Speaker at IBBC Tech Forum — AI as an Engine for National Transformation",
    desc: "Invited to speak at the Iraq Britain Business Council Tech Forum on the role of AI and technology in driving national transformation in Iraq.",
    link: "https://iraqbritainbusiness.org/news/ibbc-tech-forum-ai-as-an-engine-for-national-transformation-in-iraq",
  },
  {
    tag: "Judge",
    tagClass: "achievement-tag--judge",
    title: "Judge — Setsquared Bristol & University of Bristol",
    desc: "Selected as a judge at a Setsquared Bristol competition in partnership with the University of Bristol, evaluating emerging tech ventures and startups.",
    link: "https://www.linkedin.com/posts/setsquared-bristol_the-judges-are-in-were-excited-to-reveal-activity-7460274457341968384-4cC9",
  },
];

const Third = () => {
  return (
    <div>
      <h2 className="section-title">Recognition &amp; Press</h2>
      <div className="achievement-grid">
        {achievements.map((a, i) => (
          <div className="achievement-card" key={i}>
            <span className={`achievement-tag ${a.tagClass}`}>{a.tag}</span>
            <div className="achievement-title">{a.title}</div>
            <p className="achievement-desc">{a.desc}</p>
            <a href={a.link} className="achievement-link" target="_blank" rel="noopener noreferrer">
              Read more →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Third;
